import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import primaryLogo from '../assets/logo/syncehs-lockup-black-v2.svg';

const SignupSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [sessionId] = useState(searchParams.get('session_id'));

  useEffect(() => {
    // Optional: You could use the session_id to fetch additional details
    // about the checkout session if needed
    console.log('Checkout session ID:', sessionId);
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-surface-bg flex flex-col justify-center items-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Logo */}
        <div className="text-center">
          <img 
            src={primaryLogo} 
            alt="SyncEHS" 
            className="h-auto w-60 max-w-full mx-auto mb-8"
          />
        </div>

        {/* Success Card */}
        <div className="bg-surface-card rounded-xl shadow-lg p-8 text-center">
          {/* Success Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-status-success-light mb-6">
            <svg className="h-8 w-8 text-status-success" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          {/* Success Message */}
          <h1 className="font-display tracking-tight text-2xl font-bold text-text-primary mb-4">
            Payment Successful!
          </h1>
          
          <div className="space-y-4 text-text-body">
            <p className="text-lg">
              Thank you for subscribing to SyncEHS!
            </p>
            
            <div className="bg-accent-blue-wash p-4 rounded-lg">
              <h2 className="font-display font-bold text-text-primary mb-2">
                What happens next?
              </h2>
              <div className="text-sm text-accent-blue space-y-2">
                <p>
                  1. <strong>Check your email</strong> - We've sent setup instructions to your admin email
                </p>
                <p>
                  2. <strong>Click the invitation link</strong> to complete your account setup
                </p>
                <p>
                  3. <strong>Set up your organization</strong> and start managing safety data
                </p>
              </div>
            </div>

            <div className="bg-surface-bg p-4 rounded-lg">
              <p className="text-sm">
                <strong>Need help?</strong> Our support team is here to assist you during setup.
                Contact us at{' '}
                <a href="mailto:info@syncehs.com" className="text-accent-blue hover:text-accent-blue-hover">
                  info@syncehs.com
                </a>
              </p>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="mt-8 space-y-3">
            <button
              onClick={() => window.location.reload()}
              className="w-full bg-accent-blue hover:bg-accent-blue-hover text-white font-medium py-2 px-4 rounded-lg transition-colors"
            >
              Resend Setup Email
            </button>
            
            <Link
              to="/login"
              className="block w-full bg-surface-bg hover:bg-surface-border text-text-body font-medium py-2 px-4 rounded-md transition-colors text-center"
            >
              Go to Login
            </Link>
          </div>

          {/* Additional Info */}
          <div className="mt-6 pt-6 border-t border-surface-border">
            <div className="flex items-center justify-center space-x-2 text-sm text-text-muted">
              <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
              <span>Your subscription is active and secured</span>
            </div>
          </div>
        </div>

        {/* Footer Links */}
        <div className="text-center space-x-4 text-sm">
          <a href="mailto:info@syncehs.com" className="text-accent-blue hover:text-accent-blue-hover">
            Contact Support
          </a>
          <span className="text-text-muted">•</span>
          <Link to="/terms" className="text-accent-blue hover:text-accent-blue-hover">
            Terms of Service
          </Link>
          <span className="text-text-muted">•</span>
          <Link to="/privacy" className="text-accent-blue hover:text-accent-blue-hover">
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignupSuccess;
